module.exports = __webpack_public_path__ + "img/klattring1.619b99d2.jpg";